import { Button, Stack, Typography } from "@mui/material"

import { colours } from "../../../StyleConstants"
import LassoModal from "../../../components/LassoModal"
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import { useNavigate } from "react-router-dom";

interface Props {
    continue: Function
}

const Continue = (props: Props) => {

    const navigate = useNavigate();

    return(
        <LassoModal open={true} onClose={() => {}}>
            <Stack alignItems="center" gap={2} padding="10px">
                <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                    Before you Continue
                </Typography>

                <Typography textAlign="center">
                    We are excited to provide you with our comprehensive dataset.
                    Please note that this dataset is quite large and may take considerable time and resources to download in its entirety.
                    To ensure a smooth experience, we recommend downloading only the specific data you need through the data wrangler.
                    This will help you save time and optimize your resources.
                </Typography>

            
                <Stack gap={4} marginTop="15px" alignItems="center">
                    <Button
                        variant="primary"
                        startIcon={<SignalCellularAltIcon/>}
                        onClick={() => navigate("/data-wrangler")}
                    >
                        Data Wrangler
                    </Button>

                    <Button
                        variant="secondary"
                        size="small"
                        onClick={() => props.continue()}
                    >
                        Continue
                    </Button>
                </Stack>


            </Stack>            
        </LassoModal>

    )


}

export default Continue